import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { UploadFIleModalAction } from "./Components/UploadFileModalAction";
import { TUploadFileMethod } from "../../types";
import { useUploadFileModal } from "../../hooks/use-upload-file-modal";
import { UploadFileData } from "./Components/UploadFileData";
import { useAppModals } from "../../../../app/state/modalSlice/hook/use-app-modals";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";
import styles from "./styles.module.css";

export const UploadFileMethodModal = () => {
  const { handleCloseModal } = useAppModals();
  const uploadFileMethod = useModalSelectors("upload_file_method_modal");
  const {
    dataFile,
    uploadMethod,
    handleSelectMethod,
    handleConfirm,
    handleFileUpload,
    handleChangeFileData,
    setDataFile,
  } = useUploadFileModal(uploadFileMethod);
  const { t } = useTranslation();
  const actions = ["url", "binary"];

  const closeModal = () => {
    handleCloseModal("upload_file_method_modal");
    setDataFile([]);
  };

  return (
    <ModalBasic
      open={uploadFileMethod.isOpen}
      title={t("userfiles.upload_file_modal_title")}
      onOk={() => {
        handleConfirm(uploadMethod as TUploadFileMethod);
        handleCloseModal("upload_file_method_modal");
      }}
      closeModal={closeModal}
      onClose={closeModal}
      buttonOkText="Подтвердить"
      hasFooter
    >
      <div className={styles["modal-body"]}>
        {actions.map((action) => (
          <UploadFIleModalAction
            key={action}
            handleClick={handleSelectMethod}
            handleFileUpload={handleFileUpload}
            uploadFileMethod={action as TUploadFileMethod}
            isOpen={action === uploadMethod}
            children={
              <UploadFileData
                dataType={uploadMethod as TUploadFileMethod}
                fileData={dataFile}
                handleFileDataChange={handleChangeFileData}
              />
            }
          />
        ))}
      </div>
    </ModalBasic>
  );
};
